import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export enum AcceptEfektikaNextAction {
  CREATE_REQUEST = 'CREATE_REQUEST', 
  MODAL_DIP_CONFIRMATION = 'MODAL_DIP_CONFIRMATION', 
  MODAL_REGULAR_LIMIT_EXCEEDED_CONFIRMATION = 'MODAL_REGULAR_LIMIT_EXCEEDED_CONFIRMATION'
}

export enum AcceptEfektikaModalSource {
  EFEKTIKA = 'efektika',
  DIP = 'dip',
  REGULAR_EXCEEDED = 'regular-exceeded'
}

@Injectable({
  providedIn: 'root'
})
export class EfektikaClientService {
  private acceptingEfektikaConfirmAction = new Subject<{action: AcceptEfektikaNextAction, data: number | null}>();
  public acceptingEfektikaConfirmAction$ = this.acceptingEfektikaConfirmAction.asObservable();

  public triggerAcceptingEfektikaNextAction(action: AcceptEfektikaNextAction, data: number | null = null): void {
    this.acceptingEfektikaConfirmAction.next({ action, data });
  }
}